import { render, staticRenderFns } from "./AxFilesystemViewerActionsBase.vue?vue&type=template&id=753220fc&scoped=true&functional=true&"
import script from "./AxFilesystemViewerActionsBase.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemViewerActionsBase.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemViewerActionsBase.vue?vue&type=style&index=0&id=753220fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "753220fc",
  null
  
)

export default component.exports